import React, {Component} from 'react'
import PropTypes from "prop-types"
import './DonateModal.css'
import {RegisteringDonationAttempt} from "../../../domain/usecases/donate/RegisteringDonationAttempt"
import LModalOpener from "../../components/lui/ui/modal/LModalOpener"
import LButton from "../../components/lui/inputs/buttons/LButton"
import LFlex from "../../components/lui/layout/lflex/LFlex"


/**
 *  DonateModal
 */
class DonateModal extends Component {

    static propTypes = {
        title:  PropTypes.string,
        cfg:    PropTypes.instanceOf('DonateModalCfg').isRequired
    }

    /**
     * @type {RefObject<HTMLFormElement>}
     */
    #formRef

    constructor(props) {
        super(props)
        this.#formRef = React.createRef()
    }


    /**
     * @param {FormEvent} e
     * @returns {boolean}
     */
    #submitHandler = (e) => {
        e.stopPropagation()
        // e.preventDefault()
        // сохранение попытки доната
        const form = this.#formRef.current;
        new RegisteringDonationAttempt().call({
            title:          this.props.title,
            sum:            form.sum.value,
            paymentType:    form.paymentType.value,
            comment:        form.comment.value
        }).then()
    }


    #setPayment( val ){
        this.#formRef.current.sum.value = val
    }


    render() {
        const {title, cfg} = this.props

        return (
            <div className="DonateModal">
                <form
                    ref={ this.#formRef }
                    method="POST"
                    action="https://yoomoney.ru/quickpay/confirm.xml"
                    // action="https://yoomoney.ru/quickpay/confirm"
                    onSubmit={this.#submitHandler}
                >
                    <LFlex vertical className='gap2'>
                        <h3>{title}</h3>

                        {/* hidden */}
                        <input type="hidden" name="receiver" value={cfg.hidden.receiver} readOnly/>
                        <input type="hidden" name="formcomment" value={cfg.hidden.formComment} readOnly/>
                        <input type="hidden" name="short-dest" value={cfg.hidden.shortDesc} readOnly/>
                        {/*<input type="hidden" name="label" value="$order_id">*/}
                        <input type="hidden" name="quickpay-form" value="donate" readOnly/>
                        <input type="hidden" name="targets" value={cfg.hidden.targets} readOnly/>
                        {/*<input type="hidden" name="targets" value="транзакция {order_id}">*/}
                        <input type="hidden" name="need-fio" value="false" readOnly/>
                        <input type="hidden" name="need-email" value="false" readOnly/>
                        <input type="hidden" name="need-phone" value="false" readOnly/>
                        <input type="hidden" name="need-address" value="false" readOnly/>
                        <input type="hidden" name="successURL" value={cfg.hidden.successUrl} readOnly/>

                        {/* Сумма */}
                        <LFlex vertical className='gap0'>
                            <div className='label'>{cfg.payment.title}</div>
                            <div className="money">
                                <input name="sum" type="number" min={cfg.payment.min} step={cfg.payment.step}
                                       defaultValue={cfg.payment.default}
                                       className='w100'
                                       required
                                />
                            </div>
                            {this.#buildPayVariants()}
                        </LFlex>

                        {/* Коммент */}
                        <LFlex vertical className='gap0'>
                            <div className='label'>{cfg.commentTitle}</div>
                            <textarea name="comment" className='w100'></textarea>
                        </LFlex>

                        {/* Pay Type */}
                        <div className='payType'>
                            <label><input type="radio" name="paymentType" value="PC"/>{cfg.paymentType.youMoney}</label>
                            <label><input type="radio" name="paymentType" value="AC"/>{cfg.paymentType.card}</label>
                        </div>

                        {/* action */}
                        <LFlex className="jc-center">
                            <LButton type="submit" variant='outline' shape='round'>{cfg.submitLabel}</LButton>
                        </LFlex>
                    </LFlex>
                </form>
            </div>
        )
    }


    /**
     * @returns {JSX.Element}
     */
    #buildPayVariants() {
        const pays = this.props.cfg.payment.variants
        const variants = pays.map((pay, index) => (
            <LButton key={index} variant='surface' size='small' shape='round'
                 onClick={ ()=>this.#setPayment(pay) }
            >{String(pay)} ₽</LButton>
        ))
        return (
            <LFlex className='gap0 flex-wrap'>{variants}</LFlex>
        )
    }

}


/**
 *  Конфиг
 */
export class DonateModalCfg {

    hidden = {
        receiver: '41001321002551',
        successUrl: 'locode.me/payout.php',
        formComment: "Locode — Поддержка разработки",
        shortDesc: "Locode — Поддержка разработки",
        targets: "Locode — Поддержка разработки"
    }

    payment = {
        title: 'Сколько перевести:',
        min: 100,
        step: null,
        default: 400,
        variants: [ 100, 200, 500, 1500, 25000 ]
    }

    commentTitle = 'Сообщение разработчикам:'

    paymentType = {
        card: 'ЮMoney',
        youMoney: 'Банковской картой'
    }

    submitLabel = "Перевести"

}


/*********************************************************************************
 *
 *  Вызов модеального окна
 *  @returns {Promise<unknown>}
 */
const openDonateModal = async function ({ title, cfg }){
    return new Promise(function (resolve) {
        const modal = new LModalOpener({
            onClose: () => {
                resolve(null)
            }
        })
        modal.setContent(
            <DonateModal title={title} cfg={cfg} />
        )
        modal.open()
    })
}
export default openDonateModal